import * as TYPES from './types';

export const contactInstructionsLoaded = (instr) => ({
  type: TYPES.CONTACTUS_INSTRUCTIONS_LOADED,
  state: {
    instructions: instr,
  },
});

export const contactsLoaded = (contactList) => ({
  type: TYPES.CONTACTUS_CONTACTS_LOADED,
  state: {
    contacts: contactList,
  },
});

export const contactInstructionsLoadFailed = () => ({
  type: TYPES.CONTACTUS_INSTRUCTIONS_LOAD_FAILED,
  state: {
    instructions: null,
  },
});

export const contactsLoadFailed = () => ({
  type: TYPES.CONTACTUS_CONTACTS_LOAD_FAILED,
  state: {
    contacts: [],
  },
});
